export class ResponsibleDto{
   id?:string;
   name?:string;
   cpf?:string;
   rg?:string;
   dateOfBirth?:string;
   fone?:string;
   email?:string;
   naturality?:string;
}
export class ResponsibleCreateDto{
    name?:string;
    cpf?:string;
    rg?:string;
    dateOfBirth?:string;
    fone?:string;
    email?:string;
    naturality?:string;
}


export class UpdateResponsibleRequest
{
  responsibleId!:string;
}
